import React from "react";
import { Layout, Menu } from "antd";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { changePageTitle } from "./slice";
import { useDispatch, useSelector } from "react-redux";
import logo from "../../../assets/images/logo-white.png";
import {
	ItemAdmin,
	ItemSupperAdmin,
	ItemUser,
} from "../../../configs/sidebarMenu";
import { RootState } from "../../../app/store";
import { roles } from "../../../configs/constant";

const { Sider } = Layout;

const Sidebar: React.FC<{
	localAuth: string[];
	activeKey?: string;
	collapsed: boolean;
	setCollapse: (value: boolean) => void;
	setTitle: (value: string) => void;
	title: string;
}> = ({ activeKey, collapsed, setCollapse, setTitle, localAuth, title }) => {
	const params = useParams();
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const { auth }: any = useSelector((state: RootState) => state.authAdmin);

	const [dataSiber, setDataSiber] = React.useState<any>();

	const route = (value: any) => {
		if (localAuth.includes("SUPER_ADMIN")) {
			let arr: any = ItemSupperAdmin;
			// ItemSupperAdmin.map((val: any) => {
			// 	if (val.children) {
			// 		arr = arr.concat(val.children);
			// 	}
			// });
			const selectedItem = arr.find((item: any) => item?.key === value);
			dispatch(changePageTitle((selectedItem?.label as string) || ""));
			navigate(value);
		} else {
			let arr: any = ItemUser;
			// ItemUser.map((val: any) => {
			// 	if (val.children) {
			// 		arr = arr.concat(val.children);
			// 	}
			// });
			const selectedItem = arr.find((item: any) => item?.key === value);
			dispatch(changePageTitle((selectedItem?.label as string) || ""));
			navigate(value);
		}
	};
	return (
		<Sider
			collapsed={collapsed}
			onCollapse={() => setCollapse(!collapsed)}
			className="bg-primary layout-menu"
		>
			<div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
				<NavLink
					to={localAuth?.includes("SUPER_ADMIN") ? "/admin/listAccount" : "#"}
				>
					<div
						className={`side-bar-logo ${
							collapsed && "side-bar-logo-collapsed"
						}`}
						onClick={() => {
							setTitle("/admin/listAccount");
							route("/admin/listAccount");
						}}
					>
						<img src={logo} alt="logo" className="w-[80%]" />
					</div>
				</NavLink>
				{localAuth?.includes("SUPER_ADMIN") ? (
					<Menu
						className="bg-primary text-white border-r-0 text-[15px]"
						mode="inline"
						items={ItemSupperAdmin}
						onClick={(value) => {
							setTitle(value?.key);
							route(value?.key);
						}}
						selectedKeys={[title]}
					></Menu>
				) : localAuth?.includes("ADMIN") ? (
					<Menu
						className="bg-primary text-white border-r-0 text-[15px]"
						mode="inline"
						items={ItemAdmin}
						onClick={(value) => {
							setTitle(value?.key);
							route(value?.key);
						}}
						selectedKeys={[title]}
					></Menu>
				) : (
					<Menu
						className="bg-primary text-white border-r-0 text-[15px]"
						mode="inline"
						items={ItemUser}
						onClick={(value) => {
							setTitle(value?.key);
							route(value?.key);
						}}
						selectedKeys={[title]}
					></Menu>
				)}
				<div
					style={{
						marginTop: "auto",
						padding: "2rem 1.875rem 4.5rem",
						textAlign: "center",
					}}
				></div>
			</div>
		</Sider>
	);
};
export default Sidebar;
